import axios from 'axios';
import AuthService from '../Services/AuthService';

export default class RequestBuilder {
  authProtocol = process.env.AUTH_PROTOCOL;
  authHost = process.env.AUTH_HOST;
  authPort = process.env.AUTH_PORT;
  accountProtocol = process.env.ACCOUNT_PROTOCOL;
  accountHost = process.env.ACCOUNT_HOST;
  accountPort = process.env.ACCOUNT_PORT;
  dataProtocol = process.env.DATA_PROTOCOL;
  dataHost = process.env.DATA_HOST;
  dataPort = process.env.DATA_PORT;
  gatewayProtocol = process.env.GATEWAY_PROTOCOL;
  gatewayHost = process.env.GATEWAY_HOST;
  gatewayPort = process.env.GATEWAY_PORT;
  j1939Protocol = process.env.J1939_PROTOCOL;
  j1939Host = process.env.J1939_HOST;
  j1939Port = process.env.J1939_PORT;
  maintenanceProtocol = process.env.MAINTENANCE_PROTOCOL;
  maintenanceHost = process.env.MAINTENANCE_HOST;
  maintenancePort = process.env.MAINTENANCE_PORT;
  rulesProtocol = process.env.RULES_PROTOCOL;
  rulesHost = process.env.RULES_HOST;
  rulesPort = process.env.RULES_PORT;
  utilizationProtocol = process.env.UTILIZATION_PROTOCOL;
  utilizationHost = process.env.UTILIZATION_HOST;
  utilizationPort = process.env.UTILIZATION_PORT;

  auth = new AuthService();

  getURL(service, url) {
    const protocol = this[`${service}Protocol`];
    const host = this[`${service}Host`];
    const port = this[`${service}Port`];

    return `${protocol}://${host}:${port}${url}`;
  }

  createAxiosInstance(service, url, cancelToken) {
    return axios.create({ baseURL: this.getURL(service, url), cancelToken });
  }

  getAuthHeader() {
    return { Authorization: this.auth.getToken() };
  }

  buildRequestConfig({ method, params, data }) {
    const config = {
      method,
      params,
      headers: this.getAuthHeader(),
    };

    if (['post', 'put'].includes(method)) {
      config.data = data;
    }

    return config;
  }

  createAdditionalRequestMap(
    { children, count, limit, order, orgID, search, sort, vendor },
    paramsBuilder,
    cancelToken
  ) {
    const additionalRequests = Math.ceil((count - limit) / limit);
    return new Array(additionalRequests).fill(1).map((x, i) => {
      return this.request(
        paramsBuilder(
          {
            children,
            includeAssetCount: false,
            order,
            orgID,
            page: i + 2,
            search,
            sort,
            vendor,
          },
          cancelToken
        )
      );
    });
  }

  async request(requestParams) {
    const { service, endpoint, cancelToken } = requestParams;

    const instance = this.createAxiosInstance(service, endpoint, cancelToken);
    return instance.request(this.buildRequestConfig(requestParams));
  }
}
